import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map, startWith } from 'rxjs';
import { NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { isGuestAuthRoute } from './services/selected-trip-url/selected-trip-url.helpers';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { TilesGridComponent } from './components/tiles-grid/tiles-grid.component';
import { ChatterPanelComponent } from './components/panels/chatter-panel/chatter-panel.component';
import { SquawksPanelComponent } from './components/panels/squawks-panel/squawks-panel.component';
import { PaymentPanelComponent } from './components/panels/payment-panel/payment-panel.component';
import { MoneyOutPaymentPanelComponent } from './components/panels/money-out-payment-panel/money-out-payment-panel.component';
import { PaymentImportancePanelComponent } from './components/panels/payment-importance-panel/payment-importance-panel.component';
import { ProfilePanelComponent } from './components/panels/profile-panel/profile-panel.component';
import { ChangePasswordPanelComponent } from './components/panels/change-password-panel/change-password-panel.component';
import { ChangeEmailPanelComponent } from './components/panels/change-email-panel/change-email-panel.component';
import { LocationSwapPanelComponent } from './components/panels/location-swap-panel/location-swap-panel.component';
import { PanelHostService } from './services/panel-host.service';
import { IonApp, IonContent, IonRouterOutlet, IonFooter, IonSplitPane, IonMenu, MenuController } from '@ionic/angular';
import { BreakpointService } from './services/breakpoint.service';
import { MainMenuService } from './services/main-menu.service';
import { MobileToolbarComponent } from "./components/mobile-toolbar/mobile-toolbar.component";
import { SlideOutPanelComponent } from './components/slide-out-panel/slide-out-panel.component';
import { IonToolbar } from '@ionic/angular';
import { TilesService } from './services/tiles.service';
import { AuthService } from './services/auth.service';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { IconService } from './services/icon.service';
import { BudgetComponent } from "./components/panels/budget/budget-panel.component";
import { AddParticipantComponent } from '@components/panels/add-participant/add-participant.component';
import { PastParticipantsComponent } from '@components/panels/past-participants/past-participants.component';
import { ParticipantImportComponent } from '@components/panels/participant-import/participant-import.component';
import { InterestedPartiesComponent } from '@components/panels/interested-parties/interested-parties.component';
import { TripQrPanelComponent } from '@components/panels/trip-qr-panel/trip-qr-panel.component';
import { AddNonRosterUserComponent } from '@components/panels/add-non-roster-user/add-non-roster-user.component';
import { PasswordResetComponent } from '@components/panels/password-reset/password-reset.component';
import { TripInvitationComponent } from '@components/panels/trip-invitation/trip-invitation.component';
import { SendMessageComponent } from '@components/panels/send-message/send-message.component';
import { EditInfoComponent } from '@components/panels/edit-info/edit-info.component';
import { RemoveFromTripComponent } from '@components/panels/remove-from-trip/remove-from-trip.component';
import { ParticipantBackgroundCheckPanelComponent } from '@components/panels/participant-background-check-panel/participant-background-check-panel.component';
import { PromoteGlComponent } from '@components/panels/promote-gl/promote-gl.component';
import { ChangeGroupSizeComponent } from '@components/panels/change-group-size/change-group-size.component';
import { EditParticipantPaymentPanelComponent } from '@components/panels/trip-finances/edit-participant-payment-panel/edit-participant-payment-panel.component';
import { EditOnlineDonationPanelComponent } from '@components/panels/trip-finances/edit-online-donation-panel/edit-online-donation-panel.component';
import { EditGlDonationPanelComponent } from '@components/panels/trip-finances/edit-gl-donation-panel/edit-gl-donation-panel.component';
import { EditFundraiserPanelComponent } from '@components/panels/trip-finances/edit-fundraiser-panel/edit-fundraiser-panel.component';
import { EditBudgetItemPanelComponent } from '@components/panels/trip-finances/edit-budget-item-panel/edit-budget-item-panel.component';
import { MoneyInSettingsPanelComponent } from '@components/panels/money-in-settings-panel/money-in-settings-panel.component';
import { FundraisingFaqPanelComponent } from '@components/panels/fundraising-faq-panel/fundraising-faq-panel.component';
import { FundraisingProfilePanelComponent } from '@components/panels/fundraising-profile-panel/fundraising-profile-panel.component';
import { EditFlightPanelComponent } from '@components/panels/trip-logistics/edit-flight-panel/edit-flight-panel.component';
import { DeleteFlightPanelComponent } from '@components/panels/trip-logistics/delete-flight-panel/delete-flight-panel.component';
import { EditTripEventPanelComponent } from '@components/panels/prep-planning/edit-trip-event-panel/edit-trip-event-panel.component';
import { UploadTeamDocumentPanelComponent } from '@components/panels/prep-planning/upload-team-document-panel/upload-team-document-panel.component';
import { RequestTravelQuotePanelComponent } from '@components/panels/prep-planning/request-travel-quote-panel/request-travel-quote-panel.component';
import { translateSignal } from '@jsverse/transloco';
import { marker } from '@jsverse/transloco-keys-manager/marker';
import { SupportChatLauncherComponent } from './components/support-chat-launcher/support-chat-launcher.component';
import { ReplacedSessionNoticeComponent } from './components/replaced-session-notice/replaced-session-notice.component';
@Component({
  selector: 'app-root',
  imports: [
    FaIconComponent,
    SidebarComponent,
    TilesGridComponent,
    ChatterPanelComponent,
    SquawksPanelComponent,
    AddParticipantComponent,
    PastParticipantsComponent,
    ParticipantImportComponent,
    InterestedPartiesComponent,
    TripQrPanelComponent,
    AddNonRosterUserComponent,
    PasswordResetComponent,
    TripInvitationComponent,
    SendMessageComponent,
    EditInfoComponent,
    RemoveFromTripComponent,
    ParticipantBackgroundCheckPanelComponent,
    PromoteGlComponent,
    ChangeGroupSizeComponent,
    EditParticipantPaymentPanelComponent,
    EditOnlineDonationPanelComponent,
    EditGlDonationPanelComponent,
    EditFundraiserPanelComponent,
    EditBudgetItemPanelComponent,
    PaymentPanelComponent,
    MoneyOutPaymentPanelComponent,
    PaymentImportancePanelComponent,
    ProfilePanelComponent,
    ChangePasswordPanelComponent,
    ChangeEmailPanelComponent,
    LocationSwapPanelComponent,
    IonApp,
    IonRouterOutlet,
    SlideOutPanelComponent,
    IonSplitPane,
    IonMenu,
    BudgetComponent,
    MoneyInSettingsPanelComponent,
    FundraisingFaqPanelComponent,
    FundraisingProfilePanelComponent,
    EditFlightPanelComponent,
    DeleteFlightPanelComponent,
    EditTripEventPanelComponent,
    UploadTeamDocumentPanelComponent,
    RequestTravelQuotePanelComponent,
    SupportChatLauncherComponent,
    ReplacedSessionNoticeComponent,
],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  breakpointService = inject(BreakpointService);
  panelHost = inject(PanelHostService);
  router = inject(Router);
  tilesService = inject(TilesService);
  authService = inject(AuthService);
  iconService = inject(IconService);
  menuController = inject(MenuController);
  mainMenu = inject(MainMenuService);
  private readonly panelTitleSignals = {
    chatter: translateSignal(marker('panel-headers.chatter')),
    squawks: translateSignal(marker('panel-headers.squawks')),
    payment: translateSignal(marker('panel-headers.payment')),
    moneyOutPayment: translateSignal(marker('panel-headers.money-out-payment')),
    paymentImportance: translateSignal(marker('panel-headers.payment-importance')),
    profile: translateSignal(marker('panel-headers.profile')),
    changePassword: translateSignal(marker('panel-headers.change-password')),
    changeEmail: translateSignal(marker('panel-headers.change-email')),
    locationSwap: translateSignal(marker('panel-headers.location-swap')),
    budget: translateSignal(marker('panel-headers.budget')),
    addParticipant: translateSignal(marker('panel-headers.add-participant')),
    pastParticipants: translateSignal(marker('panel-headers.past-participants')),
    participantImport: translateSignal(marker('panel-headers.participant-import')),
    interestedParties: translateSignal(marker('panel-headers.interested-parties')),
    tripQr: translateSignal(marker('panel-headers.trip-qr')),
    addNonRosterUser: translateSignal(marker('panel-headers.add-non-roster-user')),
    passwordReset: translateSignal(marker('panel-headers.password-reset')),
    tripInvitation: translateSignal(marker('panel-headers.trip-invitation')),
    sendMessage: translateSignal(marker('panel-headers.send-message')),
    editInfo: translateSignal(marker('panel-headers.edit-info')),
    removeFromTrip: translateSignal(marker('panel-headers.remove-from-trip')),
    backgroundCheck: translateSignal(marker('panel-headers.background-check')),
    promoteGl: translateSignal(marker('panel-headers.promote-gl')),
    moneyInSettings: translateSignal(marker('panel-headers.money-in-settings')),
    fundraisingFaq: translateSignal(marker('panel-headers.fundraising-faq')),
    deleteFlight: translateSignal(marker('panel-headers.delete-flight')),
    uploadTeamDocument: translateSignal(marker('panel-headers.upload-team-document')),
    requestTravelQuote: translateSignal(marker('panel-headers.request-travel-quote')),
    fundraisingProfile: translateSignal(marker('panel-headers.fundraising-profile')),
  };

  readonly panelTitles = computed(() => ({
    chatter: this.panelTitleSignals.chatter(),
    squawks: this.panelTitleSignals.squawks(),
    payment: this.panelTitleSignals.payment(),
    moneyOutPayment: this.panelTitleSignals.moneyOutPayment(),
    paymentImportance: this.panelTitleSignals.paymentImportance(),
    profile: this.panelTitleSignals.profile(),
    changePassword: this.panelTitleSignals.changePassword(),
    changeEmail: this.panelTitleSignals.changeEmail(),
    locationSwap: this.panelTitleSignals.locationSwap(),
    budget: this.panelTitleSignals.budget(),
    addParticipant: this.panelTitleSignals.addParticipant(),
    pastParticipants: this.panelTitleSignals.pastParticipants(),
    participantImport: this.panelTitleSignals.participantImport(),
    interestedParties: this.panelTitleSignals.interestedParties(),
    tripQr: this.panelTitleSignals.tripQr(),
    addNonRosterUser: this.panelTitleSignals.addNonRosterUser(),
    passwordReset: this.panelTitleSignals.passwordReset(),
    tripInvitation: this.panelTitleSignals.tripInvitation(),
    sendMessage: this.panelTitleSignals.sendMessage(),
    editInfo: this.panelTitleSignals.editInfo(),
    removeFromTrip: this.panelTitleSignals.removeFromTrip(),
    backgroundCheck: this.panelTitleSignals.backgroundCheck(),
    promoteGl: this.panelTitleSignals.promoteGl(),
    moneyInSettings: this.panelTitleSignals.moneyInSettings(),
    fundraisingFaq: this.panelTitleSignals.fundraisingFaq(),
    deleteFlight: this.panelTitleSignals.deleteFlight(),
    uploadTeamDocument: this.panelTitleSignals.uploadTeamDocument(),
    requestTravelQuote: this.panelTitleSignals.requestTravelQuote(),
    fundraisingProfile: this.panelTitleSignals.fundraisingProfile(),
  }));

  tilesVisible = this.tilesService.tilesVisible;
  mobileMenuOpen = signal(false);
  isMobile = this.breakpointService.isMobile;

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(() => this.router.url),
      startWith(this.router.url),
    ),
    { initialValue: this.router.url },
  );

  /** Authenticated shell chrome — hidden on guest auth routes until navigation leaves them. */
  readonly showAppChrome = computed(
    () =>
      this.authService.isAuthenticated()
      && !this.authService.sessionReplaced()
      && !isGuestAuthRoute(this.currentUrl()),
  );

  readonly showReplacedSessionNotice = this.authService.sessionReplaced;

  constructor() {
    this.iconService.registerIcons();
  }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        void this.menuController.close('main-menu');
        if (!event.url.includes('dashboard')) {
          this.hideTilesPanel();
        }
      }
    });
  }

  showTilesPanel() {
    this.tilesService.showTiles();
  }

  hideTilesPanel() {
    this.tilesService.hideTiles();
  }


  openProfilePanel() {
    this.panelHost.open('profile');
  }

  navigateTo(page: string) {
    // Navigation logic
  }
}
